import ApiClient from "../../../../../lib/apiClient";
import { FileDocument } from "../types";

class DocumentApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  getDocument = async (documentId: string) =>
    this._apiClient.get<FileDocument>(`documents/${documentId}`);

  downloadDocument = async (documentId: string): Promise<BlobPart> => {
    return this._apiClient.download(`documents/download/${documentId}`);
  };

  deleteDocument = async (documentId: string) => {
    const bodyFormData = new FormData();
    bodyFormData.append("id", documentId);

    return this._apiClient.post(`documents/remove`, bodyFormData, {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob",
    });
  };
}

export default DocumentApiClient;
